<template>
    <div>
        <div style="width:100%;height: 180px" >
        <div style="float:right">
            <s-elo :elo="joueurs[joueur.numero].elo"/>
        </div>
        
        <div>
            <div v-if="tournoi.options.mode!='FORME'" >
                <div class="numero">{{parseInt(joueur.numero)+1}}</div>
                <div class="pseudo" v-if="joueurs[joueur.numero].pseudo!=''">{{joueurs[joueur.numero].pseudo}}</div>
                <div class="pseudo" v-if="joueurs[joueur.numero].pseudo==''"><i>Anonyme</i></div>
                <div class="nomprenom">{{joueurs[joueur.numero].nom}} {{joueurs[joueur.numero].prenom}}</div>
               
            </div>
            <div v-if="tournoi.options.mode=='FORME'" >
                <div class="numero">{{parseInt(joueur.numero)+1}}</div>
                <div class="pseudo" >
                    <s-input width="250px" v-model="nameEquipe" theme="is-primary" :disabled="role!='owner' && role!='admin'"/>
                    &nbsp;<s-button icon="save" @onclick="renameEquipe()" label="" theme="is-primary is-normal" :role="role"/>
                </div>
                
                <div class="coequipier"><b>Capitaine :</b> {{joueurs[joueur.numero].nom}} {{joueurs[joueur.numero].prenom}}</div>
                <div v-if="getCoequipier(joueurs[joueur.numero].coequipier1)!=null" class="coequipier">
                    <div style="float:right">
                        &nbsp;<s-button theme="is-danger is-small" icon="user-slash" label="" @onclick="supCoequipier('J2', getCoequipier(joueurs[joueur.numero].coequipier1).numero)"/>
                    </div>
                    <b>Cooequipier 1 :</b>{{getCoequipier(joueurs[joueur.numero].coequipier1).pseudo}}
                    <div class="nomprenom">{{getCoequipier(joueurs[joueur.numero].coequipier1).nom}} {{getCoequipier(joueurs[joueur.numero].coequipier1).prenom}}</div>
                </div>
                <div v-if="getCoequipier(joueurs[joueur.numero].coequipier1)==null" class="coequipier">
                    &nbsp;<s-button @onclick="addCoequipier('J2')" theme="is-success is-small" icon="user-add" label="Ajouter un coequipier" :role="role"/>
                </div>
                <div v-if="getCoequipier(joueurs[joueur.numero].coequipier2)!=null" class="coequipier">
                    <div style="float:right">
                        &nbsp;<s-button theme="is-danger is-small" icon="user-slash" label="" @onclick="supCoequipier('J3', getCoequipier(joueurs[joueur.numero].coequipier2).numero)" :role="role"/>
                    </div>
                    <b>Cooequipier 2 :</b>{{getCoequipier(joueurs[joueur.numero].coequipier2).pseudo}}
                    <div class="nomprenom">{{getCoequipier(joueurs[joueur.numero].coequipier2).nom}} {{getCoequipier(joueurs[joueur.numero].coequipier2).prenom}}</div>
                </div>
                <div v-if="getCoequipier(joueurs[joueur.numero].coequipier2)==null && getCoequipier(joueurs[joueur.numero].coequipier1)!=null" class="coequipier">
                    &nbsp;<s-button @onclick="addCoequipier('J3')" theme="is-success is-small" icon="user-add" label="Ajouter un coequipier" :role="role"/>
                </div>
            </div>
        </div>

        </div>
        <div v-if="joueurEquipe" style="margin-top: 100px">
            <div  v-for="(valueGagnesByPartie, indexGagnesByPartie) in joueurEquipe.gagnesByPartie">
               Partie {{indexGagnesByPartie+1}}: 
               <span v-if="aGagne(joueurEquipe.gagnesByPartie, indexGagnesByPartie)">Gagné </span>
               <span v-else>Perdu </span>
            </div>
        </div>
        
        <div class="buttons">
            <div v-show="joueurs[joueur.numero].invite">
                <s-button  label="Editer"
                            theme="is-info  is-normal"
                            @onclick="editerInviter"
                            icon="edit"
                            mode="V"
                            :role="role"
                />
            </div>
           
            <div  v-show="affectMembre">
                <s-button :label="labelAffect"
                            theme="is-info  is-normal"
                            @onclick="$emit('affectMembre')"
                            icon="users"
                            mode="V"
                            :role="role"
                />
            </div>
            
           
            <div  v-show="changerJoueurShow">
                <s-button :label="tournoi.options.mode=='FORME' ? 'Changer l\'équipe de jeu' : 'Changer d équipe'"
                        theme="is-warning  is-normal"
                        @onclick="changerJoueur"
                        icon="arrows-alt-h"
                        mode="V"
                        :role="role"
                />
            </div>
             <div  v-show="changerJoueurShow">
                <s-button label="Abandonner"
                        theme="is-warning  is-normal"
                        @onclick="abandonner"
                        icon="user-minus"
                        mode="V"
                        :role="role"
                />
            </div>
            <div  v-show="deleteJoueur">
                    <s-button :label="this.club.id=='demo' ? 'Enlever(non accessible en test)' : 'Enlever'"
                            theme="is-danger is-normal"
                            @onclick="confirmDeleteJoueur=true"
                            icon="user-slash" 
                            mode="V"
                            :role="role"
                            :disabled="club.id=='demo'"
                    />
                </div>
        </div>
        <s-confirm
            title="Enlever un joueur de la partie courante"
            :open="confirmDeleteJoueur"
            :close="false"
            @yes="deleteJoueurPartie"
            @no="confirmDeleteJoueur=false"
        >
            Souhaitez vous vraiment enlever le joueur {{joueurs[joueur.numero].pseudo}} ({{parseInt(joueur.numero)+1}}) 
            de cette partie ? <hr/>
            <div class="notification is-danger">
                Attention: vous enlevez le joueur de la partie courante mais il reste sur les autres parties...
                Si vous vous souhaitez le supprimer définitivement du tournoi, il faut le supprimer dans chaque partie...<br/>
                <b>Une fois supprimé de toutes les parties, il sera impossible de le rajouter</b>
            </div>
        </s-confirm>
        <edit-invit
            :open="modalInvite"
            @refresh=""
            @close="modalInvite=false"
            :joueur="joueurs[joueur.numero]"
            :joueurs="joueurs"
            :tournoi="tournoi"
            :club="club"
            @inviteToMembre="inviteToMembre"
        />
        <s-modal
            title="Abanndonner à partir de quelle partie ?"
            :open="modalAbandon"
            :close="true"
            @close="modalAbandon=false"
        >
        
            <s-l id="abonnerPartie">
                Le joueur abandonne la partie à partir de :
            </s-l>
            <div>
            <div v-for="indexPartieCurrent in parties.length" :key="indexPartieCurrent" style="margin:5px;display:inline-block">
                <s-button :label="'partie '+(parseInt(indexPartieCurrent))" 
                :theme="abandonIsParti(indexPartieCurrent) ? 'is-black' : 'is-primary'"
                :disabled="parties.length!=indexPartieCurrent ? parties[indexPartieCurrent-1].state=='FINISH' : false"
                @onclick="abandonnePartie(indexPartieCurrent-1)" />
            </div>
            <div style="margin:5px;display:inline-block">
                <s-button label="prochaine partie" 
                :theme="abandonIsParti(parties.length+1) ? 'is-black' : 'is-primary'"
                @onclick="abandonnePartie(parties.length)" />
            </div>
            </div>
            <div>
                <s-button label="Annuler l'abondon des parties" @onclick="annulerAbandon()" theme="is-warning" icon="undo"/>
            </div>
        </s-modal> 
        <s-modal 
                title="Ajouter un coequipier"
                :close="true"
                @close="modalJoueur=false"
                :open="modalJoueur"
        >
        <joueur-modal 
                :role="role" 
                :club="club" 
                :tournoi="tournoi" 
                :changeMembre="null"
                @changeMembre=""
                @refresh="" 
                @close="modalJoueur=false"
                @addJoueurInTournoiInProgress="addJoueurInTournoiInProgress"
                :indexPartie="0"
                v-if="modalJoueur" />
        </s-modal>
    </div>
</template>
<style scoped>
    .coequipier  {
        font-size: 18px;
        padding: 10px;
        margin-top: 5px;
        border: thin solid gray;
    }
    .numero {
        border-radius: 20px;
        background-color: rgb(11, 138, 22);
        width: 40px;
        height: 40px;
        text-align: center;
        padding-top: 8px;
        color: white;
        font-weight: bold;
        display: inline-block;
    }
    .pseudo {
        font-size: 20px;
        font-weight: bold;
        display: inline-block;
        margin-left: 20px;
    }
    .nomprenom {
        font-size: 16px;
        margin-left: 40px;
    }
    .ELO {
        border: thin black solid;
        padding: 5px;
        width: 100px;
        text-align: center;
        font-size: 15px;
        color: black;
        border-radius: 20px;
        margin-bottom: 20px;
        float: right;
    }
    .buttons {
        width: 100%;
        
        padding: 10px;
        margin-top: 10px;
        display: flex;
        justify-content:  space-between;
    }
</style>
<script>
import joueur_fct from "@/firebase/joueur"
import JoueurModal from "@/views/joueurs/list.vue"
import editInvit from "@/views/joueurs/editInvite.vue"

export default {
    props: ["joueur","equipe","joueurs","deleteJoueur","changerJoueurShow","affectMembre", "tournoi", "club","parties"],
    data() {
        return {
            confirmDeleteJoueur: false,
            modalJoueur: false,
            Jx: null,
            modalInvite: false,
            modalAbandon: false
        }
           
    },
    components: {
        JoueurModal,
        editInvit
    },
 
    computed: {
        role: {
            get() {
            if (this.club.id=='demo') {
                return 'owner';
            }
            return this.$getRole();
            }
        },
        labelAffect: {
            get() {
                if (this.tournoi.options.mode == 'FORME')
                    return 'Changer de capitaine'
                if (this.joueurs[this.joueur.numero].pseudo=='')
                    return 'Affecter un joueur';
                else    
                    return 'Changer de joueur'
            }
        },
        nameEquipe: {
            get() {
                if (typeof(this.joueurs[this.joueur.numero].nameEquipe)=="undefined")
                    return this.joueurs[this.joueur.numero].pseudo;
                else if (this.joueurs[this.joueur.numero].nameEquipe== '')
                    return this.joueurs[this.joueur.numero].pseudo;
                else
                    return this.joueurs[this.joueur.numero].nameEquipe
            },
            set(val) {
                this.joueurs[this.joueur.numero].nameEquipe = val;
            }
        },
        joueurEquipe: {
            get() {
                if (this.equipe!=null) {
                    for (var joueur in this.equipe.joueurs) {
                        if (this.equipe.joueurs[joueur]!=null)
                            if (this.equipe.joueurs[joueur].numero == this.joueur.numero)
                                return this.equipe.joueurs[joueur];
                    }
                    for (var joueur in this.equipe.contre) {
                        if (this.equipe.contre[joueur]!=null)
                            if (this.equipe.contre[joueur].numero == this.joueur.numero)
                                return this.equipe.contre[joueur];
                    }
                }
            }
        }
    },
    methods: {
        renameEquipe() {
            console.log("BON ALORS QUOI")
            this.$emit("renameEquipe");
        },
        abandonIsParti(indexPartie) {
            var abandonJoueurs = this.tournoi.options.abandonJoueurs;
            var flag = false;
            if (typeof(abandonJoueurs)!="undefined") {
                if (typeof(abandonJoueurs[this.joueur.numero])!="undefined") {
                    flag = abandonJoueurs[this.joueur.numero] < indexPartie;
                }
            }
            return flag;
        },
        abandonnePartie( indexPartie) {
            this.$emit("abandonnePartie", this.joueur, indexPartie, true);  
            this.modalAbandon = false;
            this.$emit("close")
        },
        annulerAbandon() {
           
            this.$emit("abandonnePartie", this.joueur, 0, false);  
            this.modalAbandon = false;
            this.$emit("close")
        },
        abandonner() {
            this.modalAbandon = true;
        },
        aGagne(gg, index) {
            var sum = 0;
            for (var i=0;i<index;i++) {
                sum+=gg[i]
            }
            return (gg[index] - sum) == 1;
        },
        editerInviter() {
            
            this.modalInvite = true;
        },
        inviteToMembre() {
            this.modalInvite=false;
            this.addModalJoueur=true;
        },
        supCoequipier(Jx, numeroSup) {
            joueur_fct.object.supCoequipier(this.club, this.tournoi, this.joueur.numero, Jx, numeroSup);
        },
        addCoequipier(Jx) {
            this.modalJoueur = true;
            this.Jx = Jx;
        },
        deleteJoueurPartie() {
            this.confirmDeleteJoueur = false;
            this.$emit("deleteJoueur")
        },
        changerJoueur() {
            this.$emit("changerJoueur")
        },
        getCoequipier(idJoueur) {
            var indexJoueur = this.joueurs.findIndex(joueur=>joueur.id === idJoueur);
            
            if (indexJoueur!=-1) {
                this.joueurs[indexJoueur].numero = indexJoueur;
                return this.joueurs[indexJoueur]
            }
                
            else
                return null;
        },
        addJoueurInTournoiInProgress(joueur) {
            delete joueur.meneur;
            joueur_fct.object.addCoequipier(this.club, this.tournoi, this.joueur, joueur, this.Jx)
            this.modalJoueur = false;
            
        }
    }
}
</script>